import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Website',
  subtitle: 'Development',
  tagline: 'High-Performance Web Development',
  // icon: '⚙️',
  icon: '',

  heroDesc: 'From stunning business websites to complex web applications, we build fast, secure, and scalable websites that perform flawlessly and grow with your business.',
  mainStat: '300+',
  mainStatLabel: 'Websites developed and delivered',
  subStats: [{ value: '<2s', label: 'Avg Load Time' }, { value: '99.9%', label: 'Uptime Guarantee' }],
  features: [
    { icon: '🌐', title: 'Custom Development', desc: 'Fully custom websites built with the latest technologies — no restrictive page builders.' },
    { icon: '⚡', title: 'Performance Optimization', desc: 'Lightning-fast load times through code optimization, caching, and CDN integration.' },
    { icon: '🔒', title: 'Security First', desc: 'SSL certificates, secure coding practices, and regular security updates.' },
    { icon: '📱', title: 'Responsive Design', desc: 'Perfect across all screen sizes — mobile, tablet, laptop, and desktop.' },
    { icon: '🔍', title: 'SEO-Ready', desc: 'Clean code structure, schema markup, and on-page SEO built in from day one.' },
    { icon: '🔧', title: 'CMS Integration', desc: 'Easy-to-manage content management systems so you can update your own website.' },
  ],
  benefits: [
    { title: 'Fast, Reliable Performance', desc: 'A slow website loses customers. We build for speed and reliability.' },
    { title: 'Grows With Your Business', desc: 'Scalable architecture means your website can grow as your business does.' },
    { title: 'Better Search Rankings', desc: 'Technical SEO built into the development process for better Google rankings.' },
    { title: 'Easy Self-Management', desc: 'User-friendly admin panels so you can manage content without technical knowledge.' },
  ],
  process: [
    { title: 'Requirements & Planning', desc: 'Detailed discussion of features, technology stack, and project timeline.' },
    { title: 'Design Implementation', desc: 'Approved designs brought to life with clean, efficient code.' },
    { title: 'Backend Development', desc: 'Database, APIs, and server-side logic built for performance and security.' },
    { title: 'Testing & QA', desc: 'Rigorous cross-browser, cross-device, and performance testing.' },
    { title: 'Launch & Handover', desc: 'Smooth deployment with training on managing your new website.' },
  ],
  whyChoose: [
    { icon: '💻', title: 'Modern Tech Stack', desc: 'React, WordPress, Node.js, and more — we use the right tool for each project.' },
    { icon: '🔍', title: 'SEO-Ready Code', desc: 'Technical SEO baked in from the start for better search visibility.' },
    { icon: '📞', title: 'Post-Launch Support', desc: '30-day post-launch support included with every project.' },
    { icon: '📖', title: 'Full Documentation', desc: 'Complete documentation and training so you can manage your site confidently.' },
  ],
  reviews: [
    { name: 'Nitin Sharma', role: 'Startup Founder', text: 'DMS built our entire platform from scratch in 6 weeks. Fast, beautiful, and bug-free!' },
    { name: 'Rekha Pillai', role: 'Healthcare Clinic', text: 'Our new website loads in under 2 seconds and our patient inquiries doubled. Remarkable!' },
    { name: 'Ajay Bhatt', role: 'Manufacturing Co.', text: 'Professional team, transparent communication, and excellent end product. 10/10.' },
  ],
  faq: [
    { q: 'What technologies do you use?', a: 'We work with React, Next.js, WordPress, PHP, MySQL, and more depending on your requirements.' },
    { q: 'How long does development take?', a: 'Simple websites: 2–4 weeks. Complex applications: 6–12 weeks. We provide detailed timelines upfront.' },
    { q: 'Do you provide hosting?', a: 'Yes, we offer managed hosting solutions. See our Domain & Hosting service for details.' },
  ],
};

export default function WebsiteDevelopment() {
  return <ServiceTemplate data={data} />;
}
